import { FormGroup } from '@angular/forms';
import { RefundVouchersFormDataBuilderInterface } from './form-data.builder.interface';

export interface RefundVouchersFormBuilderInterface {
  getForm(data: RefundVouchersFormDataBuilderInterface): FormGroup;
}
